export default "__VITE_ASSET__duL$K4kq__"